import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import App from './index';
import { appLocales, defaultLanguage } from '../../lang';

import Menu from '../Menu';
import Work from '../Work';
import WorkDetails from '../WorkDetails';
import About from '../About';
import Feed from '../Feed';
import NotFound from '../404';
import ScrollToTop from '../../components/helpers/ScrollToTop';
import Input from '../../components/form/Input';

class Routes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: null
    };
  }

  render() {
    let userLocale = navigator.language || navigator.userLanguage || 'en';
    let locale = userLocale.toLowerCase().split(/[_-]+/)[0];

    if (appLocales.indexOf(locale) === -1) {
      locale = defaultLanguage;
    }

    if (
      this.state.password !== process.env.REACT_APP_PASSWORD &&
      process.env.REACT_APP_PASSWORD
    )
      return (
        <div style={{ padding: 10 }}>
          <Input
            placeholder="Code to enter"
            onChange={event => {
              this.setState({
                password: event.target.value
              });
            }}
          />
        </div>
      );

    return (
      <ScrollToTop>
        <App>
          <div>
            <Menu />
            <Switch>
              <Route exact path="/" component={Work} />
              <Route
                exact
                path="/work/:slug/:slugProject"
                component={WorkDetails}
              />
              <Route exact path="/work/:slug?" component={Work} />
              <Route exact path="/about" component={About} />
              <Route exact path="/all" component={Feed} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </App>
      </ScrollToTop>
    );
  }
}

export default withRouter(Routes);



// WEBPACK FOOTER //
// ./src/containers/App/routes.js